import React, { useState, useEffect, useCallback, use, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DevisList.css';
//import InvoiceForm from '../InvoiceFormx';
import { Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Pagination, PaginationItem, PaginationLink, Popover, PopoverBody, Row, Spinner } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaCashRegister, FaCheckCircle, FaEdit, FaEllipsisH, FaFilePdf, FaFilter, FaInfo, FaPlus, FaSearch, FaTrash } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import DevisForm from './DevisForm';
import { devisActions } from '../../sagas/devisSlice';
import { useNavigate } from 'react-router-dom';
import { convertNumberToWords, formatPrice } from '../../helpers/utility';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import autoTable from 'jspdf-autotable';
import { productActions } from '../../sagas/productSlice';
import { debounce } from 'lodash';
import { clientActions } from '../../sagas/clientSlice';
import Select from "react-select";
import { generateDoc } from '../../helpers/generateDoc';

const DevisList = () => {
    const dispatch = useDispatch();
    const list = useSelector((state) => state.devis.list);
    const loading = useSelector((state) => state.devis.loading);
    const [filter, setFilter] = useState('');
    const { company } = useSelector(state => state.auth);
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();
    const [selectedDevis, setSelectedDevis] = useState(null);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unites
    const clients = useSelector(state => state.clients.clients);
    const [selectedClient, setSelectedClient] = useState(null);

    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const searchInputRef = useRef(null);

    const [filters, setFilters] = useState({
        clientId: null,
        chantierId: null,
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        query: ''
    });


    useEffect(() => {
        dispatch(clientActions.search({ query: "" }));
        dispatch(productActions.findAllUnites());
    }, []);

    useEffect(() => {
        let payload = {
            ...filters,
        };
        dispatch(devisActions.list(payload));
    }, [filters.clientId, filters.chantierId, filters.dateFrom, filters.dateTo, filters.commercialId]);


    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [list]);

    const handleGeneratePdf = async (devis) => {
        Swal.fire({
            title: t('commande.pdfPriceOption', 'Prix à afficher'),
            text: t('commande.pdfPriceOptionText', 'Choisissez le type de prix à afficher dans le PDF'),
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('commande.prixTTC', 'Prix TTC'),
            cancelButtonText: t('commande.prixHT', 'Prix HT'),
            showCloseButton: true,
            closeButtonHtml: '&times;',
        }).then((result) => {
            if (result.dismiss === Swal.DismissReason.close) {
                return;
            }

            const showTTCPrices = result.isConfirmed;
            generateDoc("devis", {
                matjarDoc: {
                    ...devis, lignes: devis.lignes.map(l => ({
                        ...l,
                        unite: unites.find(u => u.code === l.unite)?.libelle
                    }))
                },
                sellerModel: company,
                priceMode: showTTCPrices ? "TTC" : "HT",
                open: true,
            });
        });
    };



    const handleDeleteDevis = (devisId) => {
        setPopoverOpen(!popoverOpen)
        Swal.fire({
            title: 'Êtes-vous sûr?',
            text: "Voulez-vous vraiment supprimer ce devis?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, supprimer!',
            cancelButtonText: 'Annuler'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(devisActions.delete({
                    id: devisId, onSuccess: () => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Supprimé!',
                            text: 'Le Devis a été supprimée.',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    }
                }));
            }
        });
    };

    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        if (selectedDevis) {
            setSelectedDevis(null);
        }
        let payload = {
            ...filters
        };
        dispatch(devisActions.list(payload));
    };


    const handleAcceptDevis = (devis) => {
        Swal.fire({
            title: 'Confirmation',
            text: "Le devis sera converti en bon de commande, voulez-vous confirmer?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(devisActions.accepterDevis({
                    id: devis.id,
                    onSuccess: () => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Accepté!',
                            text: 'Le devis a été accepté avec succès.',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        let payload = {
                            ...filters
                        };
                        dispatch(devisActions.list(payload));
                    }
                }));
            }
        });
    };

    const handleUpdateDevis = (devis) => {
        setSelectedDevis(devis);
        setShowModal(true);
        setPopoverOpen(!popoverOpen)
    };

    const debouncedSearch = () => {
        dispatch(devisActions.list({
            ...filters,
        }));
    }

    const clearFilters = () => {
        setFilters({
            query: '',
            clientId: null,
            chantierId: null,
            dateFrom: formatDate(todayDate),
            dateTo: formatDate(tomorrowDate)
        });
    };

    const clientOptions = clients?.map(client => ({
        value: client.id,
        label: client.typeClient === 'PARTICULIER'
            ? `${client.nom} ${client.prenom || ''} `
            : client.entreprise,
        chantiers: client.chantiers || []
    })) ?? [];

    const clientOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...clientOptions
    ];

    // Create chantier options from selected client's chantiers
    const chantierOptions = selectedClient?.chantiers?.map(chantier => ({
        value: chantier.id,
        label: `${chantier.code} - ${chantier.nom}`,
        ...chantier
    })) || [];

    const chantierOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...chantierOptions
    ];

    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaCashRegister className="text-primary me-2" />
                                {t('devis.list')}
                            </h4>
                            <div className="d-flex align-items-center">
                                <Button color="primary" onClick={handleShowModal}>
                                    <FaPlus className="mr-2" /> {t('devis.newDevis')}
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                    {loading ? ( // Show spinner when loading
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t('common.loading')}</div>
                        </div>
                    ) : (
                        <>
                            <div className="filter-container mb-4">
                                <Row className="mb-3 g-2 align-items-end">
                                    <Col lg={4} md={4} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('reglement.search')}</Label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light">
                                                    <FaSearch />
                                                </span>
                                                <Input
                                                    type="text"
                                                    innerRef={searchInputRef}
                                                    placeholder={t('devis.searchPlaceholder')}
                                                    value={filters.query}
                                                    onChange={e => {
                                                        const value = e.target.value.toUpperCase();
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            query: value
                                                        }));
                                                    }}
                                                    className="text-uppercase"
                                                    style={{ textTransform: 'uppercase' }}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter') {
                                                            debouncedSearch(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md={3}>
                                        <FormGroup className="mb-0">
                                            <Label htmlFor="clientId">{t('bonLivraison.client')}:</Label>
                                            <Select
                                                id="clientId"
                                                options={clientOptionsWithAll}
                                                value={clientOptionsWithAll.find(option => option.value === filters.clientId)}
                                                onChange={(selectedOption) => {
                                                    setFilters(f => ({ ...f, clientId: selectedOption ? selectedOption.value : null }));
                                                    setSelectedClient(selectedOption);
                                                }}
                                                placeholder={t('bonLivraison.selectClient')}
                                                isSearchable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateFrom" className="mb-1">Date début</Label>
                                            <Input
                                                type="date"
                                                id="dateFrom"
                                                value={filters.dateFrom}
                                                onChange={e => setFilters(f => ({ ...f, dateFrom: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateTo" className="mb-1">Date fin</Label>
                                            <Input
                                                type="date"
                                                id="dateTo"
                                                value={filters.dateTo}
                                                onChange={e => setFilters(f => ({ ...f, dateTo: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                                        <Button
                                            color="secondary"
                                            onClick={clearFilters}
                                            title={t('common.clearFilters')}
                                            className="mb-3"
                                            style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <FaFilter />
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                            <table className="table table-hover table-striped table-bordered" style={{ fontSize: '0.8rem' }}>
                                <thead className="thead-light">
                                    <tr>
                                        <th className="align-middle text-center">{t('devis.numero')}</th>
                                        <th className="align-middle text-center">{t('devis.client')}</th>
                                        <th className="align-middle text-center">{t('common.user')}</th>
                                        <th className="align-middle text-center">{t('devis.dateCreation')}</th>
                                        <th className="align-middle text-center">{t('devis.dateOperation')}</th>
                                        <th className="align-middle text-center">{t('devis.montantTTC')}</th>
                                        <th className="align-middle text-center">{t('devis.montantHT')}</th>
                                        <th className="align-middle text-center">{t('devis.montantTVA')}</th>
                                        <th className="align-middle text-center">{t('devis.status')}</th>
                                        <th className="align-middle text-center">{t('common.actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list.map((devis) => (
                                        <tr key={devis.id}>
                                            <td className="align-middle text-center">{devis.numero}</td>
                                            <td className="align-middle text-center">
                                                {devis.clientNom}
                                            </td>
                                            <td className="align-middle text-center">{devis.createdBy || '-'}</td>
                                            <td className="align-middle text-center">{devis.dateCreation}</td>
                                            <td className="align-middle text-center">{devis.dateOperation || '-'}</td>
                                            <td className="align-middle text-center">{formatPrice(devis.montantTotalTTC)}</td>
                                            <td className="align-middle text-center">{formatPrice(devis.montantTotalHT)}</td>
                                            <td className="align-middle text-center">{formatPrice(devis.montantTotalTaxe)}</td>
                                            <td className="align-middle text-center">
                                                {devis.statut === 'EN_ATTENTE' && (
                                                    <span className="badge bg-secondary">{t('devis.statusDraft')}</span>
                                                )}
                                                {devis.statut === 'VALIDE' && (
                                                    <span className="badge bg-success">{t('devis.statusValidated')}</span>
                                                )}
                                                {devis.statut === 'ANNULE' && (
                                                    <span className="badge bg-danger">{t('devis.statusCancelled')}</span>
                                                )}
                                            </td>
                                            <td className="align-middle text-center">
                                                <div className="btn-group">
                                                    <Button
                                                        color="secondary"
                                                        title={t('devis.downloadPdf')}
                                                        onClick={() => handleGeneratePdf(devis)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaFilePdf />
                                                    </Button>

                                                    {devis.statut === 'EN_ATTENTE' && <Button
                                                        color="success"
                                                        title={t('devis.devisValide')}
                                                        onClick={() => handleAcceptDevis(devis)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaCheckCircle />
                                                    </Button>}

                                                    <Button
                                                        color="warning"
                                                        title={t('devis.edit')}
                                                        onClick={() => handleUpdateDevis(devis)}
                                                        size="sm"
                                                        className='me-1'
                                                    >
                                                        <FaEdit />
                                                    </Button>
                                                    {devis.statut === 'EN_ATTENTE' && <Button
                                                        color="danger"
                                                        title={t('devis.cancel')}
                                                        onClick={() => handleDeleteDevis(devis.id)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaTrash />
                                                    </Button>}

                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {list.length === 0 && (
                                        <tr>
                                            <td colSpan="10" className="text-center py-4">
                                                <div className="text-muted">{t('devis.noDevis')}</div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </>)}
                </CardBody>
            </Card>
            <Modal isOpen={showModal} toggle={handleCloseModal} size="xl"
                className="modal-fullscreen-lg-down"
                style={{ maxWidth: '95%', width: '95%', margin: '10px auto' }}
            >
                <ModalHeader toggle={handleCloseModal}

                >{selectedDevis ? `${t('devis.editDevis')} N° ${selectedDevis.numero}` : t('devis.newDevis')}</ModalHeader>
                <ModalBody>
                    <DevisForm preloadedCompany={company} devis={selectedDevis} onClose={handleCloseModal} />
                </ModalBody>
            </Modal>
        </Container>
    );
};

export default DevisList;